export default __webpack_public_path__ + "static/media/Hero-Picture 6 - without text.b218d20d.jpg";